import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import ThemeProvider from "./components/feature/ThemeProvider";
import CookieBanner from "./components/feature/CookieBanner";
import { usePageTracking } from "./hooks/usePageTracking";

function TrackingWrapper() {
  usePageTracking();
  return null;
}

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <ThemeProvider>
        <BrowserRouter basename={__BASE_PATH__}>
          <TrackingWrapper />
          <AppRoutes />
          <CookieBanner />
        </BrowserRouter>
      </ThemeProvider>
    </I18nextProvider>
  );
}

export default App;
